<app-modal #modal></app-modal>
<div *ngFor="let tableSection of tableSections" class="latestapi-home body-table FileTable mt-0">
  <div class="offline-airline-profile-table">
    <h4 id="{{ tableSection.heading }}">{{ tableSection.title }}</h4>
    <p *ngIf="tableSection.body !== ''">{{ tableSection.body }}</p>
     <div [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>